import { useSuspenseQuery } from "@tanstack/react-query";

import { authService } from "services/auth";
import { getFireboltCoreConfig } from "services/liteRuntimeConfig";
import { ReactQueryKeysAccount } from "services/queryKeys";

import { getUserByLogin } from "./getUserByLogin";
import { User } from "./user.types";

export const fetchCurrentUser = async () => {
  if (process.env.REACT_APP_LITE) {
    return getFireboltCoreConfig();
  }
  const auth0user = await authService.auth0client.getUser();
  const loginName = auth0user?.email;
  return getUserByLogin(loginName as string);
};

export const useCurrentUser = () => {
  const { data } = useSuspenseQuery<Partial<User>, Error>({
    queryKey: [ReactQueryKeysAccount.currentUser],
    queryFn: fetchCurrentUser,
  });

  return data;
};
